import { createSelector } from "reselect";

export const getData = state => state.ui.exportAddressBook;

export const getExportAddressBooksTotalResults = createSelector(
  getData,
  ({ totalResults }) => totalResults
);
